module.exports = __webpack_public_path__ + "img/jobmule_comuni.2dc4f2d9.png";